<template>
  <div class="payment-record" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车牌号码</p>
          </a-col>
          <a-col>
            <a-input v-model="table.search.number" placeholder="请输入车牌号码" allow-clear></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>支付状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择支付状态">
              <a-select-option value="paid">已支付</a-select-option>
              <a-select-option value="unpaid">未支付</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
			
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>支付时间</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.time" class="app-block" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
			
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
          <a-button @click="exportTable">导出</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange"></a-table>
  </div>
</template>

<script>
  import PaymentRecordService from '@/io/payment_record.js';

  export default {
    name: 'PaymentRecord',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            number: null,
            status: [],
            time: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '车牌号码',
              dataIndex: 'car_no'
            },
            {
              title: '车场名称',
              dataIndex: 'parking_info.park_name'
            },
            {
              title: '入场时间',
              dataIndex: 'enter_time'
            },
            {
              title: '停车时长',
              dataIndex: 'parking_time'
            },
            {
              title: '支付金额',
              dataIndex: 'total_fee'
            },
            {
              title: '支付时间',
              dataIndex: 'pay_time'
            },
            {
              title: '缴费状态',
              dataIndex: 'payStatusText'
            }
          ]
        }
      }
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    activated () {
      if (this.communityId) {
        this.initData();
      }
    },
    methods: {
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          number: null,
          status: [],
          time: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        return PaymentRecordService.listPage(
          this.communityId,
          this.table.search.number,
          this.table.search.status,
          this.table.search.time[0],
          this.table.search.time[1],
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.payStatusText = val.pay_status === 1 ? '已支付' : '未支付';
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
      exportTable() {
        PaymentRecordService.exportList(
          this.communityId,
          this.table.search.number,
          this.table.search.status,
          this.table.search.time[0],
          this.table.search.time[1]
        )
      }
    },
  }
</script>

<style lang="less" scoped>

</style>